export { default as Services } from "./Services";

// Group all reducers into a single object for dynamic inclusion
const reducers = {
	servicesReady: require("./reducers/servicesReady").default,
	systemHealth: require("./reducers/systemHealth").default,
	systemNotifications: require("./reducers/systemNotifications").default,
	clientConfig: require("./reducers/config").default,
	application: require("./reducers/applicationProfile").default,
	i18n: require("./reducers/i18n").default,
	baseMaps: require("./reducers/baseMaps").default,
	statusCards: require("./reducers/statusCards").default,
	ecoSettings: require("./reducers/ecoSettings").default,
	eventLookups: require("./reducers/eventLookups").default,
	duressStatus: require("./reducers/duress").default,
	evacuationAccountability: require("./reducers/evacuationAccountability").default
};

// Default export: all reducers as a single object
export default reducers;
